import styled, { StyledProps } from 'styled-components/macro';
import { CSSProperties } from 'react';

export type IconStylesProps = StyledProps<{
  size?: 'base' | 'lg' | 'sm';
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
}>;

const sizeMap: { [key: string]: string } = {
  base: '1.5rem',
  lg: '2rem',
  sm: '1rem',
};

export const IconStyled = styled.svg<IconStylesProps>`
  width: ${(props) => sizeMap[props.size || 'base']};
  height: ${(props) => sizeMap[props.size || 'base']};
`;
